module.exports = __webpack_public_path__ + "img/13watercraft.35d51cd6.svg";